import { cn as a } from "../../utils/utils.js";
import { jsx as i } from "react/jsx-runtime";
import { Loader2Icon as t } from "lucide-react";
function p({ className: r, ...o }) {
  return /* @__PURE__ */ i(t, {
    role: "status",
    "aria-label": "Loading",
    className: a("size-4 animate-spin text-primary-600", r),
    ...o
  });
}
export {
  p as Spinner
};

//# sourceMappingURL=spinner.js.map